import {
  GoHireNotificationEnum,
  GoServiceNotificationEnum,
  NotificationType,
  isGoServiceNotification,
} from "../enums/notifications";

import { User } from "../../../types/types";
import { Service, ServiceContract } from "../../GoService/types/service.type";
import { ServiceTypeEnum } from "../../GoService/enum/service.enum";

type BaseNotification = {
  id: number;
  type: NotificationType;
  createdAt: number;
  sentAt: number;
  additionalProperties: {
    user?: User;
    serviceContract?: (ServiceContract & { serviceRequestId?: number }) | null;
    service?: Service | null;
    requestId?: number;
    requesterId?: number;
    serviceId?: number;
    postId?: number;
    userId?: number;
    serviceType?: ServiceTypeEnum;
  };
  count: number;
  additionalPropertiesJson: {
    requestId?: number;
    requesterId?: number;
    serviceId?: number;
    postId?: number;
    userId?: number;
    footballEntityId?: number;
    serviceType?: ServiceTypeEnum;
    jobId?: number;
    candidateId?: number;
  };
};

export type GoServiceNotification = BaseNotification & {
  type: GoServiceNotificationEnum;
  message: string;
  title: string;
};

export type GoHireNotification = BaseNotification & {
  type: GoHireNotificationEnum;
  message: string;
  title: string;
  additionalPropertiesJson: {
    jobId: number;
    jobName: string;
    candidateId: number;
    applicationId: string;
  };
};
export type Notification =
  | GoServiceNotification
  | GoHireNotification
  | (BaseNotification & { type: Exclude<NotificationType, GoServiceNotificationEnum> });

export const isGoService = (n: Notification): n is GoServiceNotification => isGoServiceNotification(n.type);

export type NotificationsResponse = {
  data: {
    items: Notification[];
    total: number;
  };
};
